module.exports = __webpack_public_path__ + "media/ubud/stairs-df1c0ec3.jpg";